import { HorizontalSpacerSeparator } from 'common-front/src/designSystem/components/separator';
import { Skeleton } from 'common/src/designSystem/components/skeleton';
import { PositionPermission } from 'common/src/graphql/permissions/dsl';
import { useTranslate } from 'common/src/util/dependencies/dependencies';
import * as React from 'react';
import { Field } from 'react-final-form';
import Group, { Label, Toggle } from './group';
import RoleFormBox from './roleFormBox';

export const MembersBox = ({ disabled }: { disabled?: boolean }) => {
    const translate = useTranslate();

    return (
        <RoleFormBox
            hideToggle={true}
            subtitle={translate('permissions_rel_37045')}
            title={translate('membres_11310')}
        >
            <Field name="role.positionPermissions">
                {({ input }) => (
                    <>
                        <Group>
                            <Label>{translate('profil_du_membr_68116')}</Label>
                            <Toggle
                                disabled={disabled}
                                permission={PositionPermission.EDIT_MEMBER}
                                value={input.value}
                                onChange={input.onChange}
                            >
                                {translate('_diter_les_info_17721')}
                            </Toggle>
                        </Group>
                        <HorizontalSpacerSeparator height="6" />
                        <Group>
                            <Label>{translate('commentaires_96492')}</Label>
                            <Toggle
                                disabled={disabled}
                                permission={PositionPermission.READ_COMMENTS}
                                subtext={translate('sans_cette_perm_08373', translate('Private'))}
                                value={input.value}
                                onChange={input.onChange}
                            >
                                {translate('lire_les_commen_55215')}
                            </Toggle>
                            <Toggle
                                disabled={disabled}
                                permission={PositionPermission.ADD_COMMENTS}
                                value={input.value}
                                onChange={input.onChange}
                            >
                                {translate('ajouter_et_supp_32493')}
                            </Toggle>
                        </Group>
                        <HorizontalSpacerSeparator height="6" />
                        <Group>
                            <Label>{translate('disponibilit_s_49923')}</Label>
                            <Toggle
                                disabled={disabled}
                                permission={PositionPermission.EDIT_AVAILABILITIES}
                                value={input.value}
                                onChange={input.onChange}
                            >
                                {translate('_diter_les_disp_75220')}
                            </Toggle>
                        </Group>
                    </>
                )}
            </Field>
        </RoleFormBox>
    );
};

export const MembersSkeletonBox = () => {
    const translate = useTranslate();

    return (
        <RoleFormBox
            hideToggle={true}
            subtitle={translate('permissions_rel_37045')}
            title={translate('membres_11310')}
        >
            <Group>
                <Label>{translate('profil_du_membr_68116')}</Label>
                <Skeleton borderRadius="$1" css={{ gridColumn: 2 }} height={20} />
            </Group>
            <HorizontalSpacerSeparator height="6" />
            <Group>
                <Label>{translate('commentaires_96492')}</Label>
                <Skeleton borderRadius="$1" css={{ gridColumn: 2 }} height={40} />
                <Skeleton borderRadius="$1" css={{ gridColumn: 2 }} height={20} />
            </Group>
            <HorizontalSpacerSeparator height="6" />
            <Group>
                <Label>{translate('disponibilit_s_49923')}</Label>
                <Skeleton borderRadius="$1" css={{ gridColumn: 2 }} height={20} />
            </Group>
        </RoleFormBox>
    );
};
